import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-factura',
  templateUrl: './factura.component.html',
  styleUrls: ['./factura.component.scss']
})
export class FacturaComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit(): void {  
  }

}
